export default __webpack_public_path__ + "static/media/kitchen3-after1-1920w.6e0139c4.avif";